import { render, staticRenderFns } from "./jobBriefing.vue?vue&type=template&id=31b30cb8"
import script from "./jobBriefing.vue?vue&type=script&lang=js"
export * from "./jobBriefing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports